// extracted by mini-css-extract-plugin
export default {"container":"Sobre_container__xGkVi","conteudo":"Sobre_conteudo__1InNI"};